"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Training = void 0;
var Training_1 = require("./Training");
Object.defineProperty(exports, "Training", { enumerable: true, get: function () { return Training_1.Training; } });
//# sourceMappingURL=index.js.map